<template>
  <div class="container p-4 max-w-5xl">
    <h1 class="text-3xl font-bold mb-6">Supprimer un chat</h1>

    <div v-if="message" class="mb-4 text-red-600">{{ message }}</div>

    <div class="flex items-center gap-2 mb-6">
      <input
        v-model="noIdentificationRecherche"
        type="text"
        placeholder="No identification"
        class="border rounded px-2 py-1"
      />
      <button
        @click="rechercherChat"
        class="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-700"
        aria-label="Rechercher chat" title="Rechercher un chat par son numéro d'identification"
      >
        Rechercher
      </button>
    </div>

    <FormulaireChat
      v-if="chatTrouve"
      :chat-initial="chatTrouve"
      mode="suppression"
      @fermer="chatTrouve = null"
    >
      <template #actions>
        <button
          type="button"
          @click="ouvrirConfirmationSuppression"
          class="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          aria-label="Supprimer le chat" title="Supprimer le chat"
        >
          Supprimer
        </button>
      </template>
    </FormulaireChat>

    <!-- Modale de confirmation suppression -->
    <div v-if="chatASupprimer"
      class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
      style="z-index: 1000"
      @click.self="annulerSuppression">
      <div class="bg-white rounded-lg shadow-lg mx-2 p-6 w-full max-w-md relative" @click.stop>
        <button
          @click="annulerSuppression"
          class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl font-bold"
          aria-label="Fermer modale"
        >
          &times;
        </button>
        <div class="mb-4 text-lg">
          Êtes-vous sûr de vouloir supprimer le chat #{{ chatASupprimer.no_identification }} ?
        </div>
        <div class="flex justify-end gap-2">
          <button
            @click="confirmerSuppression"
            class="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            aria-label="Confirmer la suppression" title="Confirmer la suppression du chat"
          >
            Oui
          </button>
          <button
            @click="annulerSuppression"
            class="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
            aria-label="Annuler la suppression" title="Annuler la suppression du chat"
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { auth } from "../firebase.js";
import { useListeChats } from "@/composables/apiListeChats.js";
import FormulaireChat from "./FormulaireChat.vue";

const { listeChats, chargerlisteChats, supprimer } = useListeChats();

const noIdentificationRecherche = ref("");
const chatTrouve = ref(null);
const chatASupprimer = ref(null);
const message = ref("");

async function rechercherChat() {
  message.value = "";
  chatTrouve.value = null;
  await chargerlisteChats();
  const chatsArray = Array.isArray(listeChats.value) ? listeChats.value : [];
  const chat = chatsArray.find(
    (c) =>
      String(c.no_identification) === String(noIdentificationRecherche.value)
  );
  if (chat) {
    chatTrouve.value = { ...chat };
  } else {
    message.value = "Aucun chat trouvé avec ce numéro d'identification.";
  }
}

// Ouvre la modale de confirmation de suppression
function ouvrirConfirmationSuppression() {
  chatASupprimer.value = { ...chatTrouve.value };
}

function annulerSuppression() {
  chatASupprimer.value = null;
}

async function confirmerSuppression() {
  if (!chatASupprimer.value) return;
  try {
    const user = auth.currentUser;
    if (!user) {
      alert("Vous devez être connecté pour supprimer un chat.");
      return;
    }
    const token = await user.getIdToken(true);
    await supprimer(chatASupprimer.value.id, token);
    message.value = "Chat supprimé avec succès !";
    chatTrouve.value = null;
    chatASupprimer.value = null;
    noIdentificationRecherche.value = "";
    await chargerlisteChats();
  } catch (error) {
    console.error("Erreur lors de la suppression:", error);
    message.value = "Erreur lors de la suppression. Veuillez réessayer.";
    chatASupprimer.value = null;
  }
}
</script>